<template lang="pug">
v-row
  v-col(cols=12)
    set-notifications
</template>

<script>
import SetNotifications from '@/modules/UserSettings/components/SetNotifications.vue';

export default {
  components: {
    SetNotifications,
  },
  data() {
    return {
      loading: {
        actionsLoading: true,
      },
    };
  },
  methods: {
    reset() {
      this.$refs.courseUnitFilters.reset();
    },
    async fetchActions(tags) {
      this.$refs.studentActions.init(tags);
    },
  },
};
</script>
